<micro-select-combo #sel
              placeholder="Resource"
              [mode]="mode"
              [(id)]="taskResourceId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="isDisabled()"
              [requires]="requires()"
>
</micro-select-combo>
